<template>
  <nav class="footer-container">
    <div class="footer-wraper">
      <div class="footer-logo">
        <img src="../assets/footer-logo.png" class="footer-logo-img" alt="" />
        <div class="footer-logo-dec">
          <div class="footer-logo-title">山海图科技</div>
          <div class="footer-logo-subTitle">Shan Hai Map</div>
        </div>
      </div>
      <div class="footer-connect">
        <h4>公司介绍</h4>
        <p>
          北京山海图科技有限公司是一家专门帮助中国企业出海发展提供本地化服务的咨询公司。我们的服务主要包括：调研选址，工商注册，资质证照，财税法务，产品准入等。
        </p>
        <p>为目标国家引进中国的资本、技术、人才实现共同发展，互利共赢。</p>
        <p v-if="!isMobileDevice()" class="cert-badge-wrap">
          <a
            v-if="showCertBadge"
            href="https://xyt.xcc.cn/getpcInfo?sn=1821135220208820224&language=CN&certType=8&url=www.shanhaimap.com"
            target="_blank"
            rel="noopener noreferrer"
            class="cert-badge-link"
          >
            <span class="cert-badge-hitarea"></span>
            <img
              class="cert-badge-img"
              src="https://program.xinchacha.com/web/1821135220208820224=www.shanhaimap.com.svg"
              width="103"
              height="38"
              alt="信创查认证"
              decoding="async"
              @error="onCertBadgeError"
            />
          </a>
        </p>
      </div>
      <div class="footer-message">
        <div class="footer-connect">
          <h4>联系我们</h4>
          <p><span>电话</span>13316527542 (卢经理)</p>
          <p><span>微信</span>13316527542</p>
          <p><span>邮箱</span>sccot@shanhaimap.com</p>
          <p>
            <span>北京公司</span
            ><span class="addr">北京市海淀区西四环北路158号1幢3层3-65</span>
          </p>
          <p>
            <span>西安公司</span
            ><span class="addr"
              >陕西省西安市高新区科技路林凯国际大厦15层1501-01-03室</span
            >
          </p>
        </div>
        <div class="footer-meta">
          <h4>官方微信小程序</h4>
          <img src="../assets/erCode.jpg" class="footer-ercode-img" alt="" />
        </div>
      </div>
    </div>
    <div class="footer-copyright">
      Copyright © www.shanhaimap.com 山海图 京ICP备16015541号-1
    </div>
  </nav>
</template>

<script>
import { isMobileDevice } from '@/utils'

export default {
  name: 'Footer',
  data() {
    return {
      showCertBadge: false,
    }
  },
  mounted() {
    if (this.isMobileDevice()) return
    this.afterPageLoad(() => {
      this.showCertBadge = true
    })
  },
  beforeDestroy() {
    if (this._onPageLoad) {
      window.removeEventListener('load', this._onPageLoad)
      this._onPageLoad = null
    }
  },
  methods: {
    isMobileDevice,
    // 等浏览器 load 完成后再请求第三方资源，避免拖住标签页 loading
    afterPageLoad(callback) {
      if (document.readyState === 'complete') {
        callback()
        return
      }
      this._onPageLoad = callback
      window.addEventListener('load', callback, { once: true })
    },
    onCertBadgeError() {
      this.showCertBadge = false
    },
  },
}
</script>

<style scoped lang="less">
@import url("@/variable.less");
.footer-container {
  color: #e0e2e8;
  // height: @footer-height;
  background-color: #041747;
  padding: 30px 0 15px 0;
}
.footer-wraper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: @base-width;
  margin: auto;
}
.footer-copyright {
  width: @base-width;
  width: @base-width;
  margin: auto;
  margin-top: 10px;
  text-align: center;
}
.footer-logo {
  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer-logo-img {
  width: 60px;
  height: 80px;
}
.footer-logo-dec {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
}
.footer-logo-title {
  letter-spacing: 6px;
  font-size: 30px;
  font-weight: bolder;
}
.footer-logo-subTitle {
  font-size: 20px;
  letter-spacing: 1px;
}
.footer-message {
  display: flex;
}
.footer-connect,
.footer-meta {
  width: 320px;
  margin-right: 40px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  .addr {
    width: 240px;
  }
  & > * {
    margin: 0;
  }
  h4 {
    font-size: 20px;
    margin-bottom: 15px;
    color: #fff;
    font-weight: bold;
  }
  p {
    font-size: 16px;
    margin-top: 10px;
  }
  span {
    margin-right: 10px;
    display: inline-block;
    width: 40px;
  }
}
.footer-meta {
  margin-right: 0;
  width: 140px;
}
.footer-ercode-img {
  width: 140px;
  height: 140px;
}
.cert-badge-wrap {
  min-height: 38px;
}
.cert-badge-link {
  position: relative;
  display: inline-block;
  height: 38px;
}
.cert-badge-hitarea {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.cert-badge-img {
  display: block;
}
</style>
